export default __webpack_public_path__ + "static/media/no_results.f4427120.png";